<template>
  <div id="app">
    <keep-alive>
      <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive">12321</router-view>
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
import userApi from "../src/api/user";
import { Toast, MessageBox } from "mint-ui";
import router from "../src/router";
import { DESKEY, decryptByDESModeCBC } from "./utils/key";
import { WebIMLogin } from "./api/WebIM";
import WebIM from "./utils/WebIM.js";

export default {
  data() {
    return {
      timer: ""
    };
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (token) {
      WebIMLogin({ friendId: "" }).then(res => {
        const data = res.data;
        let options = {
          apiUrl: WebIM.config.apiURL,
          user: data.mdPass.phone,
          pwd: data.mdPass.passWord,
          appKey: WebIM.config.appkey
        };
        WebIM.conn.open(options);
      });
      userApi.summary().then(res => {
        if (this.$route.path !== "/personal") {
          this.wechatOpenId = res && res.data && res.data.wechatOpenId;
          this.$store.commit("setOpenId", this.wechatOpenId);
          let curLink = window.location.href;
          let isShowWechatPopup = !(
            curLink.indexOf("login") > 0 || curLink.indexOf("wechat-bind") > 0
          );
          if (
            (!this.$store.state.base.openid ||
              this.$store.state.base.openid == null ||
              this.$store.state.base.openid == "undefined") &&
            isShowWechatPopup
          ) {
            this.notifyWeChatBind(); //微信是否绑定的提示
          }

          this.timer = setInterval(() => {
            if (
              !this.$store.state.base.openid ||
              this.$store.state.base.openid == null ||
              (this.$store.state.base.openid == "undefined" &&
                isShowWechatPopup)
            ) {
              this.notifyWeChatBind(); //微信是否绑定的提示
            }
          }, 1000 * 60 * 60 * 5);
        }
      });
      
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    notifyWeChatBind: function() {
      MessageBox.confirm("", {
        message: "绑定微信之后，才能接收微信消息 和 微信付款。",
        title: "请绑定微信",
        confirmButtonText: "立即绑定"
      }).then(action => {
        router.push({ path: "wechat-bind",query:{backUrl: this.$route.fullPath } });
      });
    }
  },
  watch: {
    $route: {
      handler: function() {
        let link = "";
        if (location.hash) {
          link = location.hash.substring(1);
          location.hash = "";
        }
        window.addEventListener("hashchange", function(e) {
          router.push(link);
        });
      },
      deep: true //深度监听
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
#app
  width 100%
  height 100%
.tit_moudule
  font-size 0.53rem
  padding 0.16rem 0
  display flex
  flex-flow row nowrap
  justify-content space-between
  border-bottom 0.01rem solid #f1f1f1
  align-items center
</style>



// WEBPACK FOOTER //
// src/App.vue